/** Extract a filename from an HTTP Content-Disposition attachment header. */
export function parseAttachmentFilename(
  contentDisposition: string | undefined
): string | null {
  if (!contentDisposition) return null

  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(contentDisposition)
  if (!match) return null

  try {
    return decodeURIComponent(match[1])
  } catch {
    // A stray percent sign in the name is not a reason to fail the download.
    return match[1]
  }
}
